import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { selectprogramsQueryItems } from '../../../../../redux/programs/selector';
import { programs } from '../../../../../redux/programs/action';
import { deepCopy } from '../../../../../common/services/common.service';
import { settings } from '../../../../../redux/settings/actions';
import UploadFiles from '../../../../../models/UploadFile';
import PageLoader from '../../../../../components/PageLoader';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { selecttenantDomainFunctionsListItems } from '../../../../../redux/TenantDomainFunctions/selector';
import * as R from "ramda"
import { selecttenantDomainsListItems } from '../../../../../redux/tenant-domains/selector';
import { selectendpointsListItems } from '../../../../../redux/endpoints/selector';
import { endpoints } from '../../../../../redux/endpoints/action';
import { selectenvironmentsListItems } from '../../../../../redux/environments/selector';
import { environments } from '../../../../../redux/environments/action';
import { selectnetworksListItems } from '../../../../../redux/networks/selector';
import { networks } from '../../../../../redux/networks/action';
import { selectphasesListItems } from '../../../../../redux/phases/selector';
import { phases } from '../../../../../redux/phases/action';
import { selectdigitalPrivateInfrastructuresListItems } from '../../../../../redux/digital-private-infrastructures/selector';
import { digitalPrivateInfrastructures } from '../../../../../redux/digital-private-infrastructures/action';
import { selectdigitalPublicInfrastructuresListItems } from '../../../../../redux/digital-public-infrastructures/selector';
import { digitalPublicInfrastructures } from '../../../../../redux/digital-public-infrastructures/action';
import { selectservicesListItems } from '../../../../../redux/services/selector';
import { services } from '../../../../../redux/services/action';
import { applications } from '../../../../../redux/applications/action';
import { selectapplicationsListItems } from '../../../../../redux/applications/selector';
import { selectPlatformWebsitesListItems } from '../../../../../redux/platform-websites/selector';
import { platformWebsites } from '../../../../../redux/platform-websites/action';
import { dbas } from '../../../../../redux/dbas/action';
import { selectDbasListItems } from '../../../../../redux/dbas/selector';
import ProgramComponent from '../components/program/program.component';


let currentChange: any = {}
const ProgramDetails= ({subscriptionInfo}: any) => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectprogramsQueryItems)
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const DomainItems = useSelector(selecttenantDomainFunctionsListItems)
  const tenaneDomainItems = useSelector(selecttenantDomainsListItems)
  const endpointItems = useSelector(selectendpointsListItems)
  const environmentItems = useSelector(selectenvironmentsListItems)
  const networkItems = useSelector(selectnetworksListItems)
  const phasesItems = useSelector(selectphasesListItems)
  const privateItems = useSelector(selectdigitalPrivateInfrastructuresListItems)
  const publicItems = useSelector(selectdigitalPublicInfrastructuresListItems)
  const serviceItems = useSelector(selectservicesListItems)
  const applicationItems = useSelector(selectapplicationsListItems)
  const websiteItems = useSelector(selectPlatformWebsitesListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const dbasItems = useSelector(selectDbasListItems)
  
const [isQuery, setIsQuery] = useState<boolean>(false)
const [
    selectedProgram,
    setSelectedProgram
  ] = useState<any>({
    MediaMappings: {
      MediaFiles: [],
      Templates: []
    },
    KeywordMappings:{
      Keywords:[]
    },
    ApplicationMappings: {
      ApplcationIds: []
    },
    DBaaSProgram: [ {
      Id: 0,
      Name:  "String",
        DBaaSEndPointIds: [0],
      DBaaSEnvironmentIds: [0],
      DBaaSNetworkIds: [0],
      DBaaSPhaseIds: [0],
      DBaaSServiceIds: [0],
      DigitalPrivateInfrastructureIds: [0],
      DigitalPublicInfrastructureIds: [0],
      PlatformWebsiteIds:[0],
      DBAIds:[],
      Price: 0

    }]
  })

  const [
    planItems,
    setPlanItems
  ] = useState<any>([])

  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])

  const [
    keywords,
    setKeywords
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);

  const [
    programImageIndex,
    setprogramImageIndex
  ] = useState<any>([])
  const fetchProgramyId= ()=>{
    dispatch(programs.query({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/programs/query`,entity:'programs',jsonData:{
          
    Records: [
      {
        
          
              "Id": subscriptionInfo?.OwnerId
          
      
       
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})

  }

  useEffect(
    () => {
          dispatch(endpoints.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/endpoints/list`,entity:'endpoints',jsonData:{}}))
        .then(()=>{
          dispatch(environments.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/environments/list`,entity:'endpoints',jsonData:{}}))
        }).then(()=>{
          dispatch(networks.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/networks/list`,entity:'endpoints',jsonData:{}}))
        }).then(()=>{
          dispatch(phases.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/phases/list`,entity:'phases',jsonData:{}}))
        }).then(()=>{
          dispatch(digitalPrivateInfrastructures.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/digital-private-infrastructures/list`,entity:'digitalPrivateInfrastructures',jsonData:{}}))
        }).then(()=>{
          dispatch(digitalPublicInfrastructures.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/digital-public-infrastructures/list`,entity:'digitalPublicInfrastructures',jsonData:{}}))
        }).then(()=>{
          dispatch(services.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/services/list`,entity:'services',jsonData:{}}))
        }).then(()=>{
          dispatch(platformWebsites.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-websites/list`,entity:'services',jsonData:{}}))
        }).then(()=>{
          dispatch(dbas.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/platform-dbas/list`,entity:'domains',jsonData:{
            }}))
        }).then(()=>{
      if (parmas?.id > 0) {
        fetchProgramyId()
        setIsLoading(false)
      }
      else{
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
        setMediaFiles(localSelectedMedia)
        const localSelectedKeywords = addNewKeywordsRow({ selectedKeywordsArg: keywords });
        setKeywords(localSelectedKeywords)
        setIsLoading(false)
      }
    
})
    },
    []
  )

  const handleLoadApplications = () => {
    const filters = planItems?.DBaaSNetworkIds.map((networkId: number) => ({
      FieldName: "Network",
      FieldType: "Number",
      FilterOperatorId: 1,
      FieldValue: networkId,  
    }));
  
    if (filters?.length > 0) {
      dispatch(applications.list({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/applications/list`,
        entity: 'applications',
        jsonData: {
          Filters: filters, 
        },
      }));
    }
  };
  
  useEffect(() => {
    if (planItems?.DBaaSNetworkIds?.length > 0) {
      handleLoadApplications();
    }
  }, [planItems?.DBaaSNetworkIds]);


  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedProgram(queryItems?.result?.items)
        setPlanItems(queryItems?.result?.items?.DBaaSProgram[0])
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: queryItems?.result?.items?.MediaMappings?.MediaFiles });
        setMediaFiles(localSelectedMedia)
        const localSelectedKeywords = addNewKeywordsRow({ selectedKeywordsArg: queryItems?.result?.items?.KeywordMappings?.Keywords });
        setKeywords(localSelectedKeywords)
      }
    },
    [isQuery]
  )

  const handleFormChange: any = ({ field, value }: any) => {
    currentChange = { value, field, idx: 0 }
    setSelectedProgram({ ...selectedProgram, [field]: value })
    setPlanItems({ ...planItems, [field]: value })
  }

  const addNewKeywordsRow = ({ selectedKeywordsArg }: any) => {
    const localSelectedKeywords = deepCopy(selectedKeywordsArg)
    const newsKeywords = {
      OwnerTypeId: 1002,
      Id: 0,
      Keyword: '',
      Description: ''
    }
    if (localSelectedKeywords.length === 0 ||
      localSelectedKeywords[localSelectedKeywords?.length - 1]?.Keyword !== ''
    ) {
      localSelectedKeywords?.push(newsKeywords)
    }

    return localSelectedKeywords
  }

  const handleFormKeywordItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(keywords);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setKeywords(items);
  }

  const setCombinationKeywordInfo = async () => {
    let localSelectedKeyword = deepCopy(keywords)
    localSelectedKeyword.splice(
      currentChange.idx,
      1,
      { ...localSelectedKeyword[currentChange.idx] }
    );
    localSelectedKeyword = addNewKeywordsRow({ selectedKeywordsArg: localSelectedKeyword });
    currentChange.field = 'KeywordsD1'
    setKeywords(localSelectedKeyword)
  }


  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedProgram({ ...selectedProgram, [fields[0]]: value });
  }

  const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      FileTypeId: 0,
      OwnerTypeId: 179,
      OwnerId: parmas?.id,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }

    return localSelectedmedia
  }
  const setCombinationmediaInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setprogramImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'program',
      type: fileType
    })
  }
  const handleSubmit = (data: any) => {
  
    mediaFiles[programImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }
  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))
    
  }
 
  const handleFormMediaChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }

  useEffect(
    () => {
      if (currentChange.field === 'FileTypeId') {
        setCombinationmediaInfo()
      }
    },
    [mediaFiles]
  )
  useEffect(
    () => {

    },
    [selectedProgram]
  )

  useEffect(
    () => {
      if (currentChange.field === 'Keyword') {
        setCombinationKeywordInfo()
      }
    },
    [keywords]
  )

  const deleteKeywordItems = async (Item: any, index: any) => {
    keywords?.splice(
      index,
      1
    )
  }
 
  const formatWebsiteListData = (data: any) => {
    return _.map(data, (product: any) => {

      const item = {
        Id: product?.message?.Id,
        WebsiteName: product?.message?.WebsiteName,


      }
      return item
    });
  }
    return (
    <>
     {getUploadFiles == 'open' && <UploadFiles  currentFilesSrc={openFile?.currentFileSrc}
    folder={openFile?.folder}
         handleClose={handleClose}
         handleFilesSubmit={handleSubmit}
         type={openFile?.type}
         ownerId={parmas?.id}
         />}
     {isLoading ? <PageLoader /> : 
          <ProgramComponent 
          changeImage={changeImage}
          domainFunctions={DomainItems?.result?.items}
          domains={tenaneDomainItems?.result?.items}
          endPoints={endpointItems?.result?.items}
          environments={environmentItems?.result?.items}
          handleClose={handleClose}
          mediaFiles={mediaFiles}
          networks={networkItems?.result?.items}
          onFormChange={handleFormChange}
          onFormItemChange={handleFormMediaChange}
          phases={phasesItems?.result?.items}
          planItems={planItems}
          privates={privateItems?.result?.items}
          publics={publicItems?.result?.items}
          selectedProgram={selectedProgram}
          services={serviceItems?.result?.items}
          keywords={keywords}
          applications={applicationItems?.result?.items}
          handleFormKeywordItemChange={handleFormKeywordItemChange}
          deleteKeywordItems={deleteKeywordItems}
          handleInnerFormChange={handleInnerFormChange}
          websites={formatWebsiteListData(websiteItems?.result?.items)}
          dbas={dbasItems?.result?.items}
          />  }
          </>
    )
    
    }
   
    export default ProgramDetails;